import { post } from "@/utils/utils";

const auditList = {
  state: {},
  mutations: {
    QUERY_BY_VERIFY_CODE(state, data) {
      state.byVerifyCode = data.result;
    },
    CHARGE_OFF_BY_CODE(state, data) {
      state.chargeOffByVerifyCode = data.result;
    },
    QUERY_VERIFY_USAGE_RECORD_LIST(state, data) {
      state.verifyUsageRecordList = data.result;
    },
    QUERY_ALL_VERIFY_USAGE_RECORD_LIST(state, data) {
      state.allVerifyUsageRecordList = data.result;
    },
    WRITE_COUPON_RULE() {},
    FREEZE_COUPON() {},
    WRITE_OFF_BY_VERIFY_CODE() {},
    WRITE_OFF() {},
    QUERY_LIST_BY_MEMBER() {},
    QUERY_COUPON_RULE_GOODS() {},
    CHARGE_OFF_VOUCHER() {},
    QUERY_LIST_BY_CARD_MEMBER() {},
    CARD_SEND_CHECK_CODE() {},
    CONFIRM_VERUFYING() {},
    FIND_BILL_NOBODY_RECEIPTSN_LIST() {},
    QUERY_VERIFY_SERVICE_PROJECT_APPLY_LIST(){},
    VERIFY_SERVICE_PROJECT_APPLY_BY_ID_MAKE_AN_APPOINTMENT_FOR_SERVICE(){},
    GET_MODEL_BY_PARAM_CODE_CANCEL(){},
    CANCEL_SERVICE_PROJECT(){},
    GUIDER_FIND_BY_VERIFY_CODE(){}
  },
  actions: {
    cancelServiceProject({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/cancelServiceProject`,
        name: "CANCEL_SERVICE_PROJECT",
        params
      });
    },
    getModelByParamCodeCancel({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/storepermissions/storeSystemParamInfo/getModelByParamCode`,
        name: "GET_MODEL_BY_PARAM_CODE_CANCEL",
        params
      });
    },

     verifyServiceProjectApplyByIdMakeAnAppointmentForService({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/verifyServiceProjectApplyById`,
        name: "VERIFY_SERVICE_PROJECT_APPLY_BY_ID_MAKE_AN_APPOINTMENT_FOR_SERVICE",
        params
      });
    },
    queryVerifyServiceProjectApplyList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryVerifyServiceProjectApplyList`,
        name: "QUERY_VERIFY_SERVICE_PROJECT_APPLY_LIST",
        params
      });
    },
    queryByVerifyCode({ commit }, params) {
      return post({
        commit,
        url: `/storeVerifyUsageRecord/findByVerifyCode`,
        name: "QUERY_BY_VERIFY_CODE",
        params
      });
    },
    chargeOffByVerifyCode({ commit }, params) {
      return post({
        commit,
        url: `/storeVerifyUsageRecord/chargeOffByVerifyCode`,
        name: "CHARGE_OFF_BY_CODE",
        params
      });
    },
    queryVerifyUsageRecordList({ commit }, params) {
      return post({
        commit,
        url: `/storeVerifyUsageRecord/findVerifyUsageRecordList`,
        name: "QUERY_VERIFY_USAGE_RECORD_LIST",
        params
      });
    },
    queryAllVerifyUsageRecordList({ commit }, params) {
      return post({
        commit,
        url: `/storeVerifyUsageRecord/findVerifyUsageRecordList`,
        name: "QUERY_ALL_VERIFY_USAGE_RECORD_LIST",
        params
      });
    },
    writeCouponRule({ commit }, params) {
      return post({
        commit,
        url: `/coupon/writeCouponOffline`,
        name: "WRITE_COUPON_RULE",
        params
      });
    },
    freezeCoupon({ commit }, params) {
      return post({
        commit,
        url: `storeVerifyUsageRecord/freezeCoupon`,
        name: "FREEZE_COUPON",
        params
      });
    },
    writeOffByVerifyCode({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/writeOffByVerifyCode`,
        name: "WRITE_OFF_BY_VERIFY_CODE",
        params
      });
    },
    writeOff({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/write_off`,
        name: "WRITE_OFF",
        params
      });
    },
    queryListByMemberMobile({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/queryListByMemberMobile`,
        name: "QUERY_LIST_BY_MEMBER",
        params
      });
    },
    findCouponRuleGoods({ commit }, params) {
      return post({
        commit,
        url: `/storeVerifyUsageRecord/deductionVoucher`,
        name: "QUERY_COUPON_RULE_GOODS",
        params
      });
    },
    chargeOffVerifyVoucher({ commit }, params) {
      return post({
        commit,
        url: `/storeVerifyUsageRecord/chargeOffVerifyCodeDeductionVoucher`,
        name: "CHARGE_OFF_VOUCHER",
        params
      });
    },
    queryListByCardMemberMobile({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/queryListByMemberMobile`,
        name: "QUERY_LIST_BY_CARD_MEMBER",
        params
      });
    },
    sendCardCheckCode({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/sendCheckCode`,
        name: "CARD_SEND_CHECK_CODE",
        params
      });
    },
    confirmVerifying({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/confirmVerifying`,
        name: "CONFIRM_VERUFYING",
        params
      });
    },
    findBillNobyReceiptSnList({ commit }, params) {
      return post({
        commit,
        url: `/storeVerifyUsageRecord/findBillNobyReceiptSnList`,
        name: "FIND_BILL_NOBODY_RECEIPTSN_LIST",
        params
      });
    },
    // 查询预约活动核销数据
    guiderFindByVerifyCode({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/storeVerifyUsageRecord/small/guiderFindByVerifyCode`,
        name: "GUIDER_FIND_BY_VERIFY_CODE",
        params
      });
    }
    
  }
};

export default auditList;
